// @flow
import * as React from 'react';
import { Box, Columns, Button, Text, Stack } from '@locus-taxy/neo-ui';

import { useDropzone } from 'react-dropzone';
import useClientId from 'common/hooks/useClientId';
import useUploadAsset from 'common/hooks/useUploadAsset';

type Props = {
    value: ?string,
    onChange: (value: ?string) => void,
    clearable: boolean,
    accept?: ?string,
    label: string,
    description: ?string,
    error: ?string
};

const ImageUploadInput = ({
    value,
    onChange,
    clearable,
    accept,
    label,
    description,
    error
}: Props): React.Node => {
    const uploadAssetMutation = useUploadAsset();
    const clientId = useClientId();

    const onDrop = acceptedFiles => {
        const [file] = acceptedFiles;
        uploadAssetMutation.mutate(
            { clientId, file },
            {
                onSuccess: url => {
                    onChange(url);
                }
            }
        );
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept,
        maxFiles: 1
    });

    return (
        <Stack space="xSmall">
            <Box backgroundColor="white" borderRadius={1} padding={4}>
                <Stack space="xSmall">
                    <Text>{label}</Text>
                    <Columns space="medium" alignY="center">
                        <Box
                            as="img"
                            height="80px"
                            width="80px"
                            src={value}
                            padding={1}
                            sx={{
                                objectFit: 'cover',
                                border: '1px solid #eee'
                            }}
                        />
                        <Stack space="xSmall">
                            <Columns space="small">
                                <Button
                                    {...getRootProps()}
                                    appearance="ghost"
                                    palette="primary"
                                    icon="add"
                                >
                                    <input {...getInputProps()} />
                                    Add
                                </Button>
                                {clearable && value ? (
                                    <Button icon="delete" appearance="ghost">
                                        Remove
                                    </Button>
                                ) : null}
                            </Columns>
                            <Text fontSize={1} color="grey.600">
                                Format: .png Resolution: 160x80px{' '}
                            </Text>
                        </Stack>
                    </Columns>
                </Stack>
            </Box>

            {error ? (
                <Text size="regular" color="red.500">
                    {error}
                </Text>
            ) : description ? (
                <Text size="regular" color="grey.600">
                    {description}
                </Text>
            ) : null}
        </Stack>
    );
};

export default ImageUploadInput;
